module.exports = __webpack_public_path__ + "img/logo-black.97ae1c19.svg";